export class Card {
  constructor (token, year, month, brand, last, cvv, paymentStatus) {
    this.token = token
    this.year = year
    this.month = month
    this.brand = brand
    this.last = last
    this.cvv = cvv
    this.paymentStatus = paymentStatus
  }
}
